import PayslipAndBenefits from "../common/PayslipAndBenefits";

const ManagerCompensation = () => <PayslipAndBenefits />;

export default ManagerCompensation;
